export default {
  title: 'Défi',
  actions: {
    create: 'créer un défi',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce challenge? ',
    delete: 'Supprimer',
    cancel: 'Annuler'
  },
  empty: {
    title: 'Aucun défi',
    message: 'Pour créer un défi, rien de plus simple, il suffit de cliquer sur le lien suivant :'
  },
  state: {
    published: 'publié',
    testing: 'en test',
    terminated: 'terminé'
  },
  modal: {
    informations: 'Informations',
    description_1: "Vous devez renseignez un nom, une description ainsi qu'une image pour votre défi. Ces derniers seront affichés directement à vos utilisateurs et devront donc être parlant, percutant et dans le possible conscit.",
    popup: 'Popup',
    description_2: 'Si vous le souhaitez, vous pouvez afficher une popup avec un message personalisé. Ces messages apparaitront au lancement du défi et pendant son déroulement, et/ou à la fin du défi suivant le statut final de ce dernier.',
    campaign: 'Campagne',
    description_3: 'Une campagne peut être lier à un défi. Si le défi est réussi, alors la campagne sera débloqué pour tout les utilisateurs y ayant participé.',
    create: {
      title: 'Créer un défi',
      fields: {
        name: 'Nom',
        period: 'Restreindre la période',
        date: {
          start: 'Début',
          end: 'Fin'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/fr/challenge.js